export const MobileBreakpoint: number = 576;
export const TabletBreakpoint: number = 768;
export const SmallDesktopBreakpoint: number = 1156;
